// extracted by mini-css-extract-plugin
export default {"antdTableContainer":"_2zlGFo-D0v4Y40EliwKCqP"};